import { DOCUMENT, inject, PLATFORM_ID, TransferState } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { ORIGIN, PATH } from '../tokens';
import { isPlatformServer, isPlatformBrowser } from '@angular/common';
import { HandledHttpResponse } from '@uzenith360/http-utils';
import GalleryPhotosListData from './fetch-event-from-db/types/gallery-photos-list-data.inteface';
import galleryPhotosListDataKey from './fetch-event-from-db/gallery-photos-list-data.key';

export const selectionsViewResolver: ResolveFn<HandledHttpResponse<GalleryPhotosListData | undefined>>
  = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const document = inject(DOCUMENT, { optional: true });

    const platformId = inject(PLATFORM_ID, { optional: true });
    const transferState = inject(TransferState, { optional: true });

    const origin = inject(ORIGIN, { optional: true }) ?? document?.location.origin ?? null;
    const path = inject(PATH, { optional: true }) ?? document?.location.pathname ?? null;

    // console.log('origin', origin)
    // console.log('route', route);
    // console.log('state', state);

    // console.log('platformId', platformId);
    // console.log('transferState', transferState);
    // console.log('path', path);
    // console.log('origin', origin);

    const defaultErrorResponse: HandledHttpResponse<undefined> = { message: 'Problem loading selections, please try again', statusCode: 500, data: undefined };

    return import('./fetch-event-from-db')
      .then(
        ({ fetchSelections }) => {
          if (platformId === null || transferState === null || path === null || origin === null) {
            console.error('Null platform or transferState or path or origin');

            return defaultErrorResponse;
          } else if (isPlatformServer(platformId)) {
            return fetchSelections(origin, path.substring(path.lastIndexOf('/') + 1))
              .then(
                (result: HandledHttpResponse<GalleryPhotosListData>) => {
                  transferState.set(galleryPhotosListDataKey, result);

                  return result;
                }
              );

          } else if (isPlatformBrowser(platformId)) {
            return transferState.get(galleryPhotosListDataKey, defaultErrorResponse);
          } else {
            console.error('Unexpected platform');

            return defaultErrorResponse;
          }
        }
      ).catch(
        (err) => {
          console.error(err);

          return defaultErrorResponse;
        }
      );
  };
